import React from 'react';
import { Form } from 'react-bootstrap';
import { MemoryType, MemoryTypeLabel } from '../memoryBankTypes';
import classes from './MemoryField.module.scss';

type MemoryTypeFieldProps = React.ComponentProps<typeof Form.Control> & {
  /** When false, the Character type option is hidden (requires character-memories permission). */
  isCharacterMemoriesEnabled?: boolean;
};

/**
 * Returns the set of memory types available in the type dropdown.
 * Character type requires the character-memories permission unless
 * the variable is already of that type (so existing variables remain editable).
 */
function getAvailableMemoryTypes(hasCharacterMemories: boolean, currentValue?: string): [string, MemoryType][] {
  return Object.entries(MemoryType).filter(([, typeValue]) => {
    if (typeValue === MemoryType.Character) {
      return hasCharacterMemories || currentValue === MemoryType.Character;
    }
    return true;
  }) as [string, MemoryType][];
}

export function MemoryTypeField(props: MemoryTypeFieldProps) {
  const {
    id,
    value = 'string',
    isCharacterMemoriesEnabled = false,
    ...rest
  } = props;

  const availableTypes = getAvailableMemoryTypes(isCharacterMemoriesEnabled, value as string);

  return (
    <Form.Group>
      <Form.Label
        htmlFor={id}
        className={classes.memoryLabel}
      >
        Type
      </Form.Label>
      <Form.Control
        id={id}
        as="select"
        value={value}
        {...rest}
      >
        {availableTypes.map(([memoryTypeKey, memoryTypeValue]) => (
          <option key={memoryTypeKey} value={memoryTypeValue}>
            {MemoryTypeLabel[memoryTypeValue] ?? memoryTypeValue}
          </option>
        ))}
      </Form.Control>
    </Form.Group>
  );
}
